import React from "react";
import { PartnerCatalog, PartnerCatalogCategory } from "../data/catalog";
import {
  CoverCategoryLayout,
  DefaultCategoryLayout,
  TitleCategoryLayout,
} from "./block_category_layout_components";

export interface BlockCategoryLayoutProps {
  partnerCatalog: PartnerCatalog;
  catalogCategory: PartnerCatalogCategory;
  ltr?: boolean;
}

export const CategoryBlockLayout = (props: BlockCategoryLayoutProps) => {
  const { partnerCatalog, catalogCategory } = props;
  const { catalogPageLayout } = catalogCategory;

  const isCoverTemplate = catalogPageLayout === "cover";
  const isLeftTitleTemplate = catalogPageLayout === "left_column_grid";
  const isRightTitleTemplate = catalogPageLayout === "right_column_grid";

  if (isCoverTemplate) {
    return (
      <CoverCategoryLayout
        partnerCatalog={partnerCatalog}
        catalogCategory={catalogCategory}
      />
    );
  }

  if (isLeftTitleTemplate) {
    return (
      <TitleCategoryLayout
        partnerCatalog={partnerCatalog}
        catalogCategory={catalogCategory}
        ltr
      />
    );
  }

  if (isRightTitleTemplate) {
    return (
      <TitleCategoryLayout
        partnerCatalog={partnerCatalog}
        catalogCategory={catalogCategory}
        ltr={false}
      />
    );
  }

  return (
    <DefaultCategoryLayout
      partnerCatalog={partnerCatalog}
      catalogCategory={catalogCategory}
    />
  );
};
